export const preferencesTableHeaders = { backgroundColor: `var(--table-header-bg)`, borderRadius: 1, p: 1 };
export const preferencesTableBox = { width: '100%', maxHeight: '300px', overflow: 'auto' };
